import { CommonLaboratoryResponse, EnumResponse } from '@/api/services/common.dto'

export enum CommonResponsibilityCodeEnum {
    PATHOLOGIST = 'PATHOLOGIST',
    RESIDENT = 'RESIDENT',
    REGISTRAR = 'REGISTRAR',
    ADMINISTRATIVE = 'ADMINISTRATIVE',
    GROSSING_RESPONSIBLE = 'GROSSING_RESPONSIBLE',
    GROSSING_COORDINATOR = 'GROSSING_COORDINATOR',
    GROSSING_CONTROLLER = 'GROSSING_CONTROLLER',
    GROSSING_TUTOR = 'GROSSING_TUTOR',
    CYTOLOGY_EXPERT = 'CYTOLOGY_EXPERT',
    PROCESSING_RESPONSIBLE = 'PROCESSING_RESPONSIBLE',
    PROCESSING_COORDINATOR = 'PROCESSING_COORDINATOR',
    PROCESSING_CONTROLLER = 'PROCESSING_CONTROLLER',
    PROCESSING_TUTOR = 'PROCESSING_TUTOR',
    EMBEDDING = 'EMBEDDING',
    CUTTING = 'CUTTING',
    STAINING = 'STAINING'
}

export interface CommonResponsibilityResponse extends EnumResponse {
    id: number
    code: CommonResponsibilityCodeEnum
}

export interface ResponsibilityAndLaboratoryResponse {
    id: number
    responsibility: CommonResponsibilityResponse
    laboratory: CommonLaboratoryResponse
}
